import React, { useEffect, useRef, useState } from "react";
import { Button } from "../../components/ui/button";

const CLIENT_IDS = {
  development: "306005128887-19ga1bg0sl09tj652icn1220v27p15co.apps.googleusercontent.com",
  production: "834750737902-mve86aq37ndgevoi7qmpn99tbuulma8u.apps.googleusercontent.com",
  stage: "767424496456-usre4ikl1guv19kjd3tviqjo443m4o74.apps.googleusercontent.com",
};

const GoogleSignInButton = ({ handleGoogleSignIn }) => {
  const [loading, setLoading] = useState(true);
  const codeClientRef = useRef(null);

  const getClientId = () => {
    const env = process.env.REACT_APP_ENV || "development";
    return CLIENT_IDS[env] || CLIENT_IDS.development;
  };

  useEffect(() => {
    const scriptUrl = "https://accounts.google.com/gsi/client";
    const existingScript = document.querySelector(`script[src="${scriptUrl}"]`);

    const initGoogleClient = () => {
      if (!window.google?.accounts?.oauth2) {
        console.error("Google Identity Services SDK not loaded.");
        return;
      }

      codeClientRef.current = window.google.accounts.oauth2.initCodeClient({
        client_id: getClientId(),
        scope: "openid profile email",
        ux_mode: "popup",
        callback: (response) => {
          if (response.code) {
            handleGoogleSignIn(response.code);
          } else {
            console.error("Google Sign-In failed: No auth code received.");
          }
        },
      });

      setLoading(false);
    };

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = scriptUrl;
      script.async = true;
      script.defer = true;
      script.onload = initGoogleClient;
      document.body.appendChild(script);

      return () => {
        document.body.removeChild(script);
      };
    } else if (window.google?.accounts?.oauth2) {
      initGoogleClient();
    } else {
      existingScript.onload = initGoogleClient;
    }
  }, [handleGoogleSignIn]);

  const handleClick = () => {
    if (codeClientRef.current) {
      codeClientRef.current.requestCode();
    } else {
      console.error("Google Sign-In client not initialized.");
    }
  };

  return (
    <Button variant="outline" onClick={handleClick} disabled={loading}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        viewBox="0 0 17 17"
        fill="none"
        className="mr-2"
      >
        <path d="M16.4999 9.02554C16.4999 8.48174 16.455 7.93501 16.359 7.40002H8.66113V10.4806H13.0693C12.8864 11.4741 12.2987 12.353 11.438 12.9115V14.9103H14.0679C15.6123 13.517 16.4999 11.4594 16.4999 9.02554Z" fill="#4285F4" />
        <path d="M8.66111 16.8416C10.8622 16.8416 12.7185 16.1332 14.0709 14.9103L11.441 12.9115C10.7093 13.3995 9.76466 13.6758 8.66411 13.6758C6.53497 13.6758 4.72971 12.2678 4.08197 10.3748H1.36807V12.4353C2.75351 15.1367 5.57536 16.8416 8.66111 16.8416Z" fill="#34A853" />
        <path d="M4.07898 10.3747C3.73712 9.38116 3.73712 8.30532 4.07898 7.31178V5.25122H1.36809C0.210557 7.51166 0.210557 10.1748 1.36809 12.4353L4.07898 10.3747Z" fill="#FBBC04" />
        <path d="M8.66111 4.00789C9.82464 3.99025 10.9492 4.41941 11.7918 5.20718L14.1219 2.92323C12.6465 1.5652 10.6883 0.818576 8.66111 0.842092C5.57536 0.842092 2.75351 2.54698 1.36807 5.25128L4.07897 7.31184C4.72371 5.41589 6.53197 4.00789 8.66111 4.00789Z" fill="#FE2C25" />
      </svg>
      Sign in with Google
    </Button>
  );
};

export default GoogleSignInButton;
